// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"responsive-menu_dropdownContainer__p6BjV","dropdown":"responsive-menu_dropdown__3kNUT","appMenu":"responsive-menu_appMenu__CIIId"};